import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "container",
  class: "welcome-container"
}
const _hoisted_2 = { class: "welcome-header" }
const _hoisted_3 = { class: "welcome-title" }
const _hoisted_4 = {
  key: 1,
  class: "load-error"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "body" }

import { useAuthFlow } from '@/composables/useAuthFlow';
import RouteNames from '@/configuration/router/names.routes';
import { StorageKeys } from '@/models/storage-keys';
import navigationService from '@/services/NavigationService';
import { useAuthStore } from '@/stores/authStore';
import { AuthUtils } from '@/utils/auth.utils';
import { StorageUtils } from '@/utils/storage.utils';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const minTime = 1500;


export default /*@__PURE__*/_defineComponent({
  __name: 'WelcomeScreenView',
  setup(__props) {

const initializationError = ref(false);

const { t } = useI18n();
const authStore = useAuthStore();
const { checkCurrentAuth, navigateAfterAuthentication } = useAuthFlow();
const pageLoadTimestamp = Date.now();
const initAuthentication = async () => {
  try {
    let navHistory = await StorageUtils.getStorageItem(StorageKeys.NAV_HISTORY);

    if (
      [RouteNames.SpainAuth, RouteNames.FranceAuth].some(
        (route) => navHistory && navHistory.endsWith(route)
      )
    ) {
      await StorageUtils.removeStorageItem(StorageKeys.NAV_HISTORY);
      navHistory = '';
    }

    const isAuth = await checkCurrentAuth();

    const elapsed = Date.now() - pageLoadTimestamp;
    if (elapsed < minTime) {
      await new Promise((resolve) => setTimeout(resolve, minTime - elapsed));
    }

    if (isAuth) {
      await navigateAfterAuthentication();
    } else {
      const targetRoute = AuthUtils.getLoginRouteName(authStore.authMethod);
      navigationService.navigateTo({ name: targetRoute });
    }
  } catch (ex) {
    console.error('Error during initialization:', ex);
    initializationError.value = true;
  }
};

initAuthentication();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!initializationError.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('welcome.title')), 1)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "progress-bar" }, [
            _createElementVNode("div", { class: "progress-bar-value" })
          ], -1))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('welcome.error.title')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('welcome.error.body')), 1)
        ]))
  ]))
}
}

})